import { render, staticRenderFns } from "./OauthFactorTablePane.vue?vue&type=template&id=52600288&"
import script from "./OauthFactorTablePane.vue?vue&type=script&lang=js&"
export * from "./OauthFactorTablePane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports